import React from 'react';

const Quote = () => (
  <div className="Quote-contain">
    <p className="Quote">
      Mathematics as an expression of the human mind
      reflects the active will, the contemplative
      reason, and the desire for aesthetic perfection.
      Its basic elements are logic and intuition,
      analysis and construction, generality and individuality.
      -
      <b> Richard Courant </b>
    </p>
  </div>
);
export default Quote;
